import { Navigate } from "react-router-dom";
import { useAuth } from "../../common/Context/AuthContext";
import { getLocalStorage, removeLocalStorage } from "../../common/Utils/Utils";

// Only accessible if NOT logged in
const PublicRoute = ({ children, redirectTo = "/products" }) => {
  const { user } = useAuth();
  const redirectCategory = getLocalStorage("category");
  const redirectProduct = getLocalStorage("redirectProduct");
  if (redirectProduct) {
    redirectTo += `#/try/${redirectProduct}`;
    removeLocalStorage("redirectProduct");
  }
  if (redirectCategory) {
    redirectTo += `?category=${encodeURIComponent(redirectCategory)}`;
    removeLocalStorage("category");
  }
  return user ? <Navigate to={redirectTo} replace /> : children;
};

export default PublicRoute;
